import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TopBar from './TopBar';
import NavigationBar from './NavigationBar';
import Footer from './Footer';
import '../../assets/css/general/mainlayout.css';
import ScrollToTop from './ScrollToTop';

const MainLayout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToFooter) {
      window.history.replaceState({}, '', location.pathname);

      setTimeout(() => {
        const footer = document.getElementById('main-footer');
        if (footer) {
          footer.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="ml-wrapper">
      {/*  Top Bar  */}
      <TopBar />

      {/*  Navigation Bar  */}
      <ScrollToTop/>
      <NavigationBar />

      {/*  Page Content  */}
      <main className="ml-main">
        {children}
      </main>

      {/*  Footer  */}
     {location.pathname !== "/aiplanner" && <Footer />}
    </div>
  );
};

export default MainLayout;